import React, { useMemo } from "react";
import { Tabs, ConfigProvider } from "antd";
import { Luggage, Backpack } from "lucide-react";
import "./flights-baggage-allowance.scss";

export function FlightsBaggageAllowance({ journeys }) {
  const flightTabs = useMemo(() => {
    const tabs = [];
    journeys.forEach((journey) => {
      journey.flights.forEach((flight) => {
        tabs.push({
          flight,
          fromCity: flight.departure.cityName || flight.departure.city,
          toCity: flight.arrival.cityName || flight.arrival.city,
          flightNo: flight.flightNo,
          dateText: formatDate(flight.departDateTime),
        });
      });
    });
    return tabs;
  }, [journeys]);

  return (
    <div className="flights-baggage-sheet">
      {/* <div className="drag-handle" /> */}

      <ConfigProvider
        theme={{
          components: {
            Tabs: {
              inkBarColor: "#CBA135",
              itemActiveColor: "#CBA135",
              itemHoverColor: "#CBA135",
              itemSelectedColor: "#CBA135",
            },
          },
        }}
      >
        <Tabs
          defaultActiveKey="0"
          type="line"
          tabPosition="top"
          items={flightTabs.map((tab, idx) => ({
            key: idx.toString(),
            label: (
              <div className="flight-tab-label">
                <span>
                  {tab.fromCity} → {tab.toCity}
                </span>
                <small>
                  {tab.dateText} {tab.flightNo}
                </small>
              </div>
            ),
            children: tab.flight.baggageAllowances?.length ? (
              <div className="tab-content">
                {tab.flight.baggageAllowances.map((allowance, i) => (
                  <PassengersAllowanceBlock key={i} allowance={allowance} />
                ))}
              </div>
            ) : (
              <p className="no-baggage">
                No baggage allowance for this flight.
              </p>
            ),
          }))}
        />
      </ConfigProvider>
    </div>
  );
}

function PassengersAllowanceBlock({ allowance }) {
  return (
    <div className="passengers-block">
      {allowance.passengerInfos.map((pax, idx) => (
        <PassengerCard
          key={idx}
          passengerName={
            pax.firstName || pax.lastName
              ? `${pax.firstName} ${pax.lastName}`.trim()
              : `PASSENGER ${idx + 1}`
          }
          carryOnLines={allowance.carryOn}
          checkedLines={allowance.checked}
        />
      ))}
    </div>
  );
}

function PassengerCard({ passengerName, carryOnLines, checkedLines }) {
  return (
    <div className="passenger-card">
      <div className="passenger-name">{passengerName}</div>

      {carryOnLines?.length ? (
        <>
          <BaggageRow
            icon={<Backpack />}
            title="Carry-on baggage"
            subtitle={carryOnLines[0]}
            details={carryOnLines.slice(1)}
          />
          <div className="dashed-divider" />
        </>
      ) : null}

      {checkedLines?.length ? (
        <BaggageRow
          icon={<Luggage />}
          title="Checked baggage"
          subtitle={checkedLines[0]}
          details={checkedLines.slice(1)}
        />
      ) : null}
    </div>
  );
}

function BaggageRow({ icon, title, subtitle, details = [] }) {
  return (
    <div className="baggage-row">
      <div className="icon-box">{icon}</div>
      <div className="baggage-info">
        <div className="title">{title}</div>
        <div className="subtitle">{subtitle}</div>
        {details.length ? (
          <div className="details">
            {details.map((d, idx) => (
              <div key={idx}>{d}</div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}

function formatDate(dateStr) {
  const dt = new Date(dateStr);
  if (isNaN(dt)) return "";
  return dt.toLocaleDateString("en-US", {
    weekday: "short",
    day: "numeric",
    month: "short",
  });
}
